import { Link } from '@tanstack/react-router'
import styles from './HeroSection.module.css'

const TICKER_ITEMS = [
  { label: 'NOVO FORMATO', value: 'Sobrevivente · exclusivo Fantyx', accent: true },
  { label: 'COPA DE SELEÇÕES', value: '11 JUN → 19 JUL 2026', hot: true },
  { label: 'FORMATOS DE LIGA', value: 'Pontos · H2H · Sobrevivente' },
  { label: 'REGRAS', value: '100% customizáveis pelo admin', accent: true },
  { label: 'ESPORTES', value: 'Futebol · CS2 · Basquete em breve' },
  { label: 'ACESSO', value: 'Lista de espera aberta', accent: true },
]

export function HeroSection() {
  return (
    <section className={styles.hero}>
      <div className={styles.heroGrid}>
        {/* Left column */}
        <div className={styles.heroLeft}>
          <div className={styles.eyebrow}>
            <span className={styles.liveDot} />
            RODADA 1 · COPA DE SELEÇÕES 2026
          </div>

          <h1 className={styles.heroTitle}>
            TUA LIGA.<br />
            TUAS REGRAS<span className={styles.slash} /><br />
            <span className={styles.glow}>TEU JOGO.</span>
          </h1>

          <p className={styles.heroSub}>
            Crie a liga, <strong>defina as regras</strong> e escolha o formato — pontos
            corridos, mata-mata H2H ou <strong>Sobrevivente</strong>, o eliminatório semanal
            que só existe aqui. Sua liga, do seu jeito.
          </p>

          <div className={styles.ctaRow}>
            <Link
              to="/entrar"
              search={{ redirect: undefined, code: undefined, error: undefined }}
              className={styles.btnSolid}
            >
              Montar meu time →
            </Link>
            <a href="#como-funciona" className={styles.btnGhost}>Como funciona</a>
          </div>

          <div className={styles.heroMeta}>
            <span>● <strong>BETA</strong> · lançamento Copa de Seleções 2026</span>
            <span>·</span>
            <span><strong>Lista de espera</strong> aberta</span>
          </div>
        </div>

        {/* Right column — broadcast card */}
        <div className={styles.heroRight}>
          <div className={styles.broadcastCard}>
            <div className={styles.broadcastBg} />
            <div className={styles.playerSilhouette} />
            <div className={styles.bcNum}>10</div>
            <div className={styles.broadcastOverlay}>
              <div className={styles.bcTop}>
                <span className={styles.bcLive}>
                  <span className={styles.bcDot} /> AO VIVO · 87'
                </span>
                <span className={styles.bcTag}>
                  FLA <strong className={styles.bcTagAcc}>2</strong> — <strong>1</strong> PAL
                </span>
              </div>
              <div className={styles.bcBottom}>
                <div className={styles.bcPmeta}>
                  <span>CAPITÃO</span>
                  <span className={styles.bcSep} />
                  <span>MEIA · BRA</span>
                  <span className={styles.bcSep} />
                  <span>RODADA 1</span>
                </div>
                <div className={styles.bcPname}>
                  MAYA<br /><span className={styles.bcPnameAcc}>VASCONCELOS</span>
                </div>
                <div className={styles.bcStats}>
                  <div className={styles.bcStat}>
                    <div className={styles.bcStatLbl}>PTS</div>
                    <div className={`${styles.bcStatVal} ${styles.bcStatValAcc}`}>+16</div>
                  </div>
                  <div className={styles.bcStat}>
                    <div className={styles.bcStatLbl}>GOLS</div>
                    <div className={styles.bcStatVal}>1</div>
                  </div>
                  <div className={styles.bcStat}>
                    <div className={styles.bcStatLbl}>ASSIST</div>
                    <div className={styles.bcStatVal}>2</div>
                  </div>
                  <div className={styles.bcStat}>
                    <div className={styles.bcStatLbl}>RTG</div>
                    <div className={styles.bcStatVal}>9.4</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Floating score overlay */}
          <div className={styles.floatScore}>
            <div className={styles.floatScoreTop}>
              <span>SEU TIME</span>
              <span className={styles.floatGain}>▲ 1º</span>
            </div>
            <div className={styles.floatLabel}>SAMURAI XI</div>
            <div className={styles.floatPts}>2.184 PTS</div>
          </div>

          {/* Floating goal toast */}
          <div className={styles.floatToast}>
            <div className={styles.floatToastHead}>⚽ GOL!</div>
            <div className={styles.floatToastWho}>Maya · Capitão</div>
            <div className={styles.floatToastDelta}>+16 pts · você subiu 4 posições</div>
          </div>
        </div>
      </div>

      {/* Ticker strip */}
      <div className={styles.ticker}>
        <div className={styles.tickerRow}>
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((item, i) => (
            <span key={i} className={styles.tickerItem}>
              <span className={styles.tickerLabel}>{item.label}</span>
              <span className={item.hot ? styles.tickerHot : item.accent ? styles.tickerAcc : undefined}>
                {item.value}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
